import requireLoggedInSaga from 'routes/helpers/requireLoggedIn'; // polyfill webpack require.ensure

if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export var ReferRoute = function ReferRoute(store) {
  return {
    path: 'refer',
    onEnter: function onEnter(nextState, replaceState, cb) {
      replaceState('/search?refer=1');
      store.runSagaOnce(requireLoggedInSaga, nextState, replaceState).done.then(cb, cb);
    }
  };
};